import { useEffect, useState } from "react";
import { GiHamburgerMenu } from "react-icons/gi";
import { useDispatch } from "react-redux";
import WorldWideLocation from "../../../Assets/icons/WorldWideLocation.png";
import calendar from "../../../Assets/icons/calendar.png";
import profile from "../../../Assets/icons/profile.png";
import search from "../../../Assets/icons/search.png";
import { OnlyToShowYear } from "../../../CommonFunction/IsoDateTime";
import { setFinancialYear } from "../../../Store/FinancialDates/FinancialDates.reducer";
import { getUserRightsDetails } from "../../../Store/UserRights/UserRights.action";
import Button from "../Button/Button";
import CompanyBranchSection from "../ComponeyAndBranchSelection/ComponyAbdBranchSelection";
import SelectFinancialYear from "../FinancialYearSelection/FinancialYearSelection";
import HamburgerDrawer from "../HamburgerDrawer/HamburgerDrawer";
import Image from "../Image/Image";
import Navdropdown from "../NavbarbuttonDropDown/Navdropdown";
import Profile from "../Profile/Profile";
import OutsideClick from "../onOutSideClick/OutSideClick";
import "./Navbar.scss";
import Sidebar from "./Sidebar";
import LRTrack from "../../Pages/LRTrack/LRTrack";

const Navbar = () => {
  const [showProfile, setShowProfile] = useState(false);
  const [toggleDropDown, settoggle] = useState(false);
  const [nav, setnav] = useState("");
  const [useInfo, setUserInfo] = useState();
  const [toggleCompony, setToggle] = useState(false);
  const [userRights, setUserRights] = useState([]);
  const [companyName, setCompanyName] = useState("");
  const [branchName, setBranchName] = useState();
  const dispatch = useDispatch();
  const [selectedFinancialYear, setSelectedFinancialYear] = useState("");
  const [toggleFinancialYear, setToggleFinancialYear] = useState(false);
  const [isSidebarOpen, setSidebarOpen] = useState(false);
  const [isSearchClicked, setSearchClicked] = useState(false);

  const toggleSidebar = () => {
    setSidebarOpen(!isSidebarOpen);
  };

  const localUserRights = sessionStorage.getItem("userRights") && JSON.parse(sessionStorage.getItem("userRights"));

  useEffect(() => {
    sessionStorage.setItem("UserSelectedBranch", JSON.stringify({}));
  }, []);

  useEffect(() => {
    async function setup() {
      let company = sessionStorage.getItem("CompanyCode") && JSON.parse(sessionStorage.getItem("CompanyCode"));
      let branch = sessionStorage.getItem("BranchCode") && JSON.parse(sessionStorage.getItem("BranchCode"));

      if (company && branch) {
        let CompanyCodeName = company?.CompanyCodeName ? company?.CompanyCodeName : company?.CompanyCode;
        setCompanyName(CompanyCodeName);
        setBranchName(branch?.Name);
      }
    }
    setup();
  }, []);

  function toggle() {
    setShowProfile(!showProfile);
  }

  useEffect(() => {
    setUserRights(localUserRights);
    let obj = {};
    if (localUserRights && localUserRights.length > 0) {
      for (let i = 0; i < localUserRights.length; i++) {
        for (let j = 0; j < localUserRights[i].Modules.length; j++) {
          for (let k = 0; k < localUserRights[i].Modules[j].Page.length; k++) {
            obj[`/${localUserRights[i].Modules[j].Page[k].Route}`] = localUserRights[i].Modules[j].Page[k];
          }
        }
      }
      dispatch(getUserRightsDetails(obj));
    }
  }, []);

  function ToggleProfile() {
    setShowProfile(false);
  }

  const changeComponyAndBranch = () => {
    setToggle(!toggleCompony);
  };

  useEffect(() => {
    const storedYear = sessionStorage.getItem("SelectedFinancialYear");
    if (storedYear) {
      const yearObj = JSON.parse(storedYear);
      handleFinancialYearChange(yearObj?.yearRange);
    }
  }, []);

  const onYearSelected = (yearRange) => {
    handleFinancialYearChange(yearRange);
  };

  const handleFinancialYearChange = (yearRange) => {
    if (!yearRange) return;
    const dates = yearRange.split(" - ");
    const startYear = OnlyToShowYear(dates[0]);
    const endYear = OnlyToShowYear(dates[1]);
    const formatted = `${startYear} - ${endYear}`;
    setSelectedFinancialYear(formatted);
    dispatch(setFinancialYear(yearRange));
  };

  const changeFinancialYear = () => {
    setToggleFinancialYear((prev) => !prev);
  };

  const closeAllDropdowns = () => {
    settoggle(false);
    setnav("");
  };

  // Check if licenseeCode is present (user is logged in) and showModalOnceFlag is not set
  // Open the CompanyBranchSection modal
  // Set flag in sessionStorage to prevent modal from opening again on refresh
  // useEffect(() => {
  //   const licenseeCode = sessionStorage.getItem("LicenseeCode");
  //   const showModalOnceFlag = sessionStorage.getItem("openModal");
  //   if (licenseeCode && !showModalOnceFlag) {
  //     setToggle(true);
  //     sessionStorage.setItem("openModal", "true");
  //   }
  // }, []);
  const handleSearchClick = () => {
    setSearchClicked(true);
  };
  return (
    <>
      <div>
        <nav className="nav">
          <div style={{ display: "flex" }}>
            <HamburgerDrawer />
            <div className="hamburger-menu " onClick={toggleSidebar} onMouseDown={(e) => e.stopPropagation()}>
              <GiHamburgerMenu />
            </div>
          </div>
          <div className="topnav">
            <div className="topnavleft">
              {userRights &&
                userRights.length > 0 &&
                userRights.map((e, index) => {
                  return (
                    <OutsideClick key={index} setToggled={settoggle}>
                      <div>
                        <Button
                          name="navbutton"
                          text={e.Menu_Name}
                          // action={() => setnav(nav === e.name ? "" : e.name)}
                          action={() => {
                            setnav(e.Menu_Name);
                            settoggle(!toggleDropDown);
                          }}
                        />
                        <Navdropdown
                          display={toggleDropDown && nav === e.Menu_Name}
                          name={nav}
                          content={e.Modules.length > 0 ? e.Modules : ""}
                          onClose={closeAllDropdowns}
                        />
                      </div>
                    </OutsideClick>
                  );
                })}
            </div>
            <div className="topnavright">
              <div className="navinfobox" onClick={handleSearchClick}>
                <Image width={"20px"} name="centerimg" img={search} />
              </div>

              <div
                className="navinfobox"
                onClick={() => {
                  changeFinancialYear();
                }}
              >
                <Image name={"navbuttonlogos"} img={calendar} />
                <Button name="navbutton yearclass" text={selectedFinancialYear || "Select Year"} />
              </div>
              <div className="navinfobox" onClick={changeComponyAndBranch}>
                <Image name={"navbuttonlogos"} img={WorldWideLocation} />{" "}
                <div className="branchComp">
                  {/* <p>{companyName}</p> */}
                  {/* <br /> */}
                  <p>{`${branchName} (${companyName})`}</p>
                </div>
              </div>
              {/* <div className="navinfobox">
                <Button
                  name="navbutton"
                  text={useInfo && useInfo[0]?.CompanyCode?.CompanyCode}
                />
              </div> */}
              <div className="navinfobox" onClick={toggle}>
                <Image name={"navbuttonlogos"} img={profile} />
                <p className="userName">{useInfo && useInfo[0]?.UserName}</p>
              </div>

              <OutsideClick setToggled={ToggleProfile}>
                <div className={showProfile ? "showProfile" : "hideProfile"}>
                  <Profile toggle={toggle} />
                </div>
              </OutsideClick>
            </div>
          </div>
        </nav>
        <div onClick={toggleSidebar}>
          <Sidebar userRights={userRights} isOpen={isSidebarOpen} closeSidebar={() => setSidebarOpen(false)} />
        </div>
        <div style={{ visibility: toggleFinancialYear ? "visible" : "hidden" }}>
          <SelectFinancialYear
            setToggle={setToggleFinancialYear}
            show={toggleFinancialYear}
            onYearSelected={onYearSelected}
          />
        </div>
        <div style={{ visibility: toggleCompony ? "visible" : "hidden" }}>
          <>
            <CompanyBranchSection setToggle={setToggle} show={toggleCompony} TypeOfPortal={""} />
          </>
        </div>
      </div>
      {isSearchClicked && <LRTrack setSearchClicked={setSearchClicked} />}
    </>
  );
};

export default Navbar;
